// extracted by mini-css-extract-plugin
module.exports = {"service-list":"Ec_8ApKuuUodOp-TO3OHJ"};